import i18n from 'services/base/i18n';

export default {
  fieldPackage: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Fields', 'Feature Package'),
  fieldBilling: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Fields', 'Billing Schedule'),
  fieldPayment: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Fields', 'Payment Method'),
  fieldStatus:  () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Fields', 'Plan Status'),

  statusActive:   () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Status', 'Active'),
  statusExpired:  () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Status', 'Expired'),
  statusInactive: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Status', 'Inactive'),

  priceFree: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Prices', 'Free'),
  priceUnavailable: () => i18n.pgettext('Pages|Manage Plans|Plan Firewall|Prices', 'Unavailable'),

  warningEffectivity: (date: string) => (i18n.sprintf(i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Warnings',
    'Your selection will not take effect until your current subscription runs out on %s.'
  ), date)),

  errorInvoice: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Errors',
    'Unable to generate invoice preview. Please try again later. If this problem persists, please contact support.'
  ),

  errorGeneric: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Errors',
    'Encountered an unknown error'
  ),

  tagLifetime: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall',
    'Lifetime Plan'
  ),
};
